/**
 * will implement in future
 */
export class WhiteListDataService {
  getWhitelistData() {
    return { entities: [] };
  }
}
